<div class="fdimlog"></div>
<div class="fdlog"></div>

<div class="titfirstev">
  <img src="./assets/img/wilout_control_logo_small.svg" title="Wilout Control" width="40px">
  <br>
  Configuration requise
</div>

<div class="blocedit blocredirect" style="display:block">
  <div class="headedit" style="color:var(--ui-color-text)">
    Aucune liste de contrôle disponible
  </div>

  <div class="messageredirect">
    <div class="iconredirect">
      <i class="far fa-clipboard-list"></i>
    </div>
    <div class="textredirect">
      Pour utiliser Wilout Control, vous devez d'abord créer votre événement et configurer vos listes de contrôle sur le
      backoffice en ligne.
    </div>
  </div>

  <div (click)="redirectToBoOnline()" class="btnredirect">
    Accéder au BO Online maintenant &nbsp;<i class="fas fa-external-link-alt"></i>
  </div>

  <div class="infotextredirect">
    Vous allez être redirigé vers le backoffice en ligne Wilout où vous pourrez concevoir votre événement.
  </div>

  <div (click)="logout()" class="logoutredirect">
    <i class="fas fa-sign-out-alt"></i> &nbsp; Se déconnecter
  </div>
</div>
